// Core imports
import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component Imports
import { Card, Col, Row } from 'antd';
import UserFeedbackScoreSection from './UserFeedbackScoreSection';
import UserFeedbackLiveChatAgentSection from './UserFeedbackLiveChatAgentSection';

// Misc imports
import { ANALYTICS_SECTIONS } from '../../constants/main';
import { useFetchUserFeedbackAnalyticsQuery } from '../../store/analytics/analyticsApi';
import { isEmptyArray } from '../../utils/is/isEmptyArray';

const AnalyticsUserFeedbackTab = ({
  requestParams,
  setIsLoading = () => false
}) => {

  const { data: userFeedbackAnalytics, isFetching: isFetchingUserFeedbackAnalytics, isUninitialized } = useFetchUserFeedbackAnalyticsQuery({ ...requestParams?.[0] }, { skip: isEmptyArray(requestParams) });

  // Memoize loading state to prevent unnecessary re-renders
  const isLoading = useMemo(() =>
    isFetchingUserFeedbackAnalytics || isUninitialized,
  [isFetchingUserFeedbackAnalytics, isUninitialized]
  );

  useEffect(() => {
    setIsLoading(isLoading);

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  const renderUserFeedbackSection = () => {
    return (
      <Fragment>
        <Row gutter={[16, 16]} className="mb-5 hide-empty" id={`analytics-section_${ANALYTICS_SECTIONS.USER_FEEDBACK.key}`}>
          <Col xs={24} md={12} xxl={12} id={`analytics-section_${ANALYTICS_SECTIONS.USER_FEEDBACK.key}_${ANALYTICS_SECTIONS.USER_FEEDBACK.subSections.OVERALL_FEEDBACK_SCORE.key}`}>
            <Card className="h-100">
              <UserFeedbackScoreSection
                data={userFeedbackAnalytics?.feedback}
                isLoading={isLoading}
                sectionTitle={t('Agent Overall Feedback Score')}
              />
            </Card>
          </Col>

          <Col xs={24} md={12} xxl={12} id={`analytics-section_${ANALYTICS_SECTIONS.USER_FEEDBACK.key}_${ANALYTICS_SECTIONS.USER_FEEDBACK.subSections.LIVE_CHAT_FEEDBACK_SCORE.key}`}>
            <Card className="h-100">
              <UserFeedbackScoreSection
                data={userFeedbackAnalytics?.liveChatFeedback}
                isLoading={isLoading}
                sectionTitle={t('LiveChat Feedback Score')}
              />
            </Card>
          </Col>

          <Col xs={24} md={12} xxl={12} id={`analytics-section_${ANALYTICS_SECTIONS.USER_FEEDBACK.key}_${ANALYTICS_SECTIONS.USER_FEEDBACK.subSections.LIVE_CHAT_AGENTS_FEEDBACK_SCORE.key}`}>
            <Card className="h-100">
              <UserFeedbackLiveChatAgentSection
                data={userFeedbackAnalytics?.liveChatAgentsFeedback}
                sectionTitle={t('Live Agents Feedback Score')}
                isLoading={isLoading}
              />
            </Card>
          </Col>
        </Row>
      </Fragment>
    );
  };
  return (
    <Fragment>
      {renderUserFeedbackSection()}
    </Fragment>
  );
};

AnalyticsUserFeedbackTab.propTypes = {
  requestParams: PropTypes.array,
  setIsLoading: PropTypes.func
};

export default AnalyticsUserFeedbackTab;
